export const environment = {
    production: false,
    sociedad: 1800,
    api100: 'https://apis100-dev.grupo-lafuente.com',
    // api100Key: 'xicYGFamJFPIn8FjL4Dyxs6oqliyiwBi',//PRD
    api100Key: 'mJA95z0bCCiHb77cHgAduABAq3eRbbAR',//DEV
    api400: {     //Api Sigel
        ruta: 'https://dev-apis400.grupo-lafuente.com/api/',
        email: 'sis@grupo-lafuente.com',
        password: '8759623'
    },
    empresas: [
        {
            sociedad: 1200,
            titulo: 'Techo',
            urlCrm: 'https://dev-crm.nuevasantacruz.com',
            credential: {
                grant_type: 'client_credentials',
                client_id: 'd32c7a2b-2a63-7bbd-73f8-611b882be95c',
                client_secret: 'crm2021',
            },
            message:
                'Techo, Deseo información sobre los proyectos disponibles. Mi nombre es: @@nombre_completo y mi ciudad de residencia es: @@ciudad',
            googleTagManagerId: null
        },
        {
            sociedad: 1300,
            titulo: 'El Pahuichi SRL',
            urlCrm: 'https://dev-crm.nuevasantacruz.com',
            credential: {
                grant_type: 'client_credentials',
                client_id: 'd32c7a2b-2a63-7bbd-73f8-611b882be95c',
                client_secret: 'crm2021',
            },
            message:
                'El Pahuichi SRL, Deseo información sobre los proyectos disponibles. Mi nombre es: @@nombre_completo y mi ciudad de residencia es: @@ciudad',
            googleTagManagerId: null
        },
        {
            sociedad: 1600,
            titulo: 'Monumental',
            urlCrm: 'https://dev-crm.nuevasantacruz.com',
            credential: {
                grant_type: 'client_credentials',
                client_id: 'd32c7a2b-2a63-7bbd-73f8-611b882be95c',
                client_secret: 'crm2021',
            },
            message:
                'Monumental, Deseo información sobre los proyectos disponibles. Mi nombre es: @@nombre_completo y mi ciudad de residencia es: @@ciudad',
            googleTagManagerId: null
        },
        {
            sociedad: 1700,
            titulo: 'Parque Industrial Latinoamericano',
            urlCrm: 'https://dev-crm.nuevasantacruz.com',
            credential: {
                grant_type: 'client_credentials',
                client_id: 'd32c7a2b-2a63-7bbd-73f8-611b882be95c',
                client_secret: 'crm2021',
            },
            message: 'Parque Industrial Latinoamericano, Deseo informaci\xF3n sobre los proyectos disponibles. Mi nombre es: @@nombre_completo y mi ciudad de residencia es: @@ciudad',
            googleTagManagerId: 'AW-16775921350'
        },
        {
            sociedad: 1800,
            titulo: 'Nueva Santa Cruz',
            urlCrm: 'https://dev-crm.nuevasantacruz.com',
            credential: {
                grant_type: 'client_credentials',
                client_id: 'd32c7a2b-2a63-7bbd-73f8-611b882be95c',
                client_secret: 'crm2021'
            },
            message: 'Nueva Santa Cruz, Deseo información sobre los proyectos disponibles. Mi nombre es: @@nombre_completo y mi ciudad de residencia es: @@ciudad',
            googleTagManagerId: 'AW-16801508776'
        },
        {
            sociedad: 2400,
            titulo: 'CasaMia',
            urlCrm: 'https://dev-crm.nuevasantacruz.com',
            credential: {
                grant_type: 'client_credentials',
                client_id: 'd32c7a2b-2a63-7bbd-73f8-611b882be95c',
                client_secret: 'crm2021',
            },
            message:
                'CasaMia, Deseo información sobre los proyectos disponibles. Mi nombre es: @@nombre_completo y mi ciudad de residencia es: @@ciudad',
            googleTagManagerId: null
        }
    ]


};